import { render, staticRenderFns } from "./ResolDeltaThermHc_1d23.vue?vue&type=template&id=3b05b5b8&"
import script from "./ResolDeltaThermHc_1d23.vue?vue&type=script&lang=js&"
export * from "./ResolDeltaThermHc_1d23.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports